import styled from 'styled-components';

export const TableContainer = styled.div`
  box-shadow: 0px 0px 5px #cccccc;
  border-radius: 8px;
  width: 100%;
  max-height: 400px;
  height: 400px;
`;

export const Table = styled.table`
  width: 100% !important;
  height: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  thead {
    background: #fff;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);

    > tr {
      width: 100%;
      height: 100%;
      display: flex;
      padding: 0 1rem;
      padding-right: 2rem;

      th {
        display: flex;
        align-items: center;
        height: 40px;
      }
    }
  }

  div {
    width: 100% !important;
    height: 100%;
    overflow-y: scroll;

    tbody {
      height: 100%;
      width: 100% !important;
      display: flex;
      flex-direction: column;
    }
  }
`;

export const TableHeadColumn = styled.th<{ width?: string }>`
  width: ${props => (props.width ? `${props.width}` : 'auto')};
  padding: 5px;
  text-align: left;
`;
